/**
 * Pure helper: decide which locale tag to use when constructing an Intl formatter
 * for hour-cycle detection.
 *
 * If `browserLanguage`'s language part (the 2–3-char code before the first hyphen)
 * matches `nlsLocale`'s language part, return `browserLanguage` (which carries the
 * region that determines 12h vs 24h). Otherwise return `nlsLocale`.
 */
export function resolveHourCycleLocale(
  nlsLocale: string,
  browserLanguage: string | undefined,
): string {
  if (!browserLanguage) return nlsLocale
  // Language part = everything before the first hyphen ("en-GB" → "en")
  const nlsLang = nlsLocale.split('-')[0]
  const browserLang = browserLanguage.split('-')[0]
  return nlsLang === browserLang ? browserLanguage : nlsLocale
}
